import {configureStore} from "@reduxjs/toolkit";
import datasetAPI from "./api/datasetAPI";
import accessLogAPI from "./api/accessLogAPI";
import groupAPI from "./api/groupAPI";
import userAPI from "./api/userAPI";
import notifications from "./notification/notifications";
import dataAPI from "./api/dataAPI";
import processedSiteDataAPI from "./api/processedSiteDataAPI";
import siteDataAPI from "./api/siteDataAPI";
import serviceAccountAPI from "./api/serviceAccountAPI";
import statisticsDataAPI from "./api/statisticsDataAPI";
import mapFiltersSlice from "./slice/mapFiltersSlice";
import statisticsProcessedDataAPI from "./api/statisticsProcessedDataAPI";
import processedMapFiltersSlice from "./slice/processedMapFiltersSlice";
import dataModeSlice from "./slice/dataModeSlice";

const store = configureStore({
    reducer: {
        datasetAPI,
        accessLogAPI,
        groupAPI,
        serviceAccountAPI,
        userAPI,
        dataAPI,
        siteDataAPI,
        processedSiteDataAPI,
        notifications,
        statisticsDataAPI,
        statisticsProcessedDataAPI,
        mapFiltersSlice,
        processedMapFiltersSlice,
        dataModeSlice  // { mode: "raw" | "processed" }
     }
})

export default store;
